import request from "root/js/request";

export const getSocialBloggersSubjects = async ({
  source__in,
  account_name_hash__in,
  brand_id__in,
  product_id__in,
  limit = 100,
  offset = 0,
  search,
  ...rest
}) => {
  const response = await request({
    url: `parsers/social/bloggers/subjects/`,
    method: "get",
    params: {
      source__in,
      account_name_hash__in,
      brand_id__in,
      product_id__in,
      limit,
      offset,
      search,
      ...rest,
    },
  });
  return response;
};
